import { Card, Link } from '@heroui/react';
import { FC, useMemo, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../core/rootHooks';
import { AppDispatch } from '../../../core/store';
import { ESelectionType } from '../../sharedEnums';
import { TSectorColourInfo } from './leftSidebarTypes';
import { createCleanOutputSelection, filterGivenVesselsByFilterCriteriaForOutput } from '../../../features/search/helper';
import { selectSubscribedVesselSearchFormData } from '../../../features/search/searchSelectors';
import { setSelectedVesselsForOutputRequest } from '../../../features/search/searchSlice';
import { selectSectorColours } from '../../sharedSelectors';
import { addSeascapeLogActivity } from '../../../activity-logging/activityLogApi';
import { SeascapeActivityLogConstants } from '../../../activity-logging/activityLogTypes';
// import { selectFeature } from '../../../routing/pageContextSlice';
import { useLocation } from 'react-router-dom';
import { selectFeature } from '../../../routing/pageContextSlice';

const SectorFilter: FC = () => {
	const dispatch = useAppDispatch<AppDispatch>();

	const location = useLocation();
	const uriParts = ['/kpis', '/green', '/value', '/dcf', '/download'];
	
	// const selectionData = useAppSelector(selectSelectionData);
	const vessels = useAppSelector(selectSubscribedVesselSearchFormData);
	const sectorColours: TSectorColourInfo[] = useAppSelector(selectSectorColours);
	const selectedFeature = useAppSelector(selectFeature);

	const sectorColoursMemo = useMemo(() => sectorColours, [sectorColours]);

	const [selectedSector, setSelectedSector] = useState<string>('');

	if (!sectorColoursMemo) return null;

	const handleSectorClick = (sectorName: string) => {
		if (selectedSector === sectorName) {
			setSelectedSector('');
			const cleanOutput = createCleanOutputSelection(vessels);
			dispatch(setSelectedVesselsForOutputRequest({ outputSelection: cleanOutput }));
		} else {
			setSelectedSector(sectorName);

			let filteredVessels = vessels;

			// Open below commented code in case of demand of selection by selected vessels
			// if (selectionData.selectionType !== ESelectionType.None && selectionData.selectedVesselsList) {
			// 	const selectedImoNumbers = new Set(selectionData.selectedVesselsList.map((v) => v.imoNumber));
			// 	filteredVessels = vessels.filter((f) => f.imoNumber !== undefined && selectedImoNumbers.has(f.imoNumber));
			// }

			const sectorFilterCriteria = { type: ESelectionType.Sector, value: sectorName };
			const sectorOutput = filterGivenVesselsByFilterCriteriaForOutput(filteredVessels, sectorFilterCriteria);
			dispatch(setSelectedVesselsForOutputRequest({ outputSelection: sectorOutput }));

			const payload = JSON.stringify({ Sector: sectorName });
			const eventId = SeascapeActivityLogConstants.SECTOR_LEGEND_CLICKED;
			addSeascapeLogActivity({ eventId, payload });
		}
	};

	if (uriParts.includes(location.pathname)) {
		return null; // or return a different component
	}

	if (selectedFeature) {
		return null; // or return a different component
	}

	if (sectorColoursMemo.length === 0) {
		return null;
	}

	return (
		<Card className={`w-32 rounded-none p-2 opacity-80 absolute`} style={{ bottom: 44 }}>
			<div className="flex flex-col space-y-0">
				{sectorColoursMemo.map((sectorColour) => (
					<Link
						key={sectorColour.sectorName + '-' + sectorColour.colour}
						className="flex justify-between gap-y-1 gap-x-1 cursor-pointer"
						onPress={() => handleSectorClick(sectorColour.sectorName)}
					>
						<div className="text-msi-midblue-color-500 text-sm">{sectorColour.sectorName}</div>
						<div style={{ backgroundColor: sectorColour.colour }} className="mt-0.5 w-4 h-3"></div>
					</Link>
				))}
			</div>
		</Card>
	);
};

export default SectorFilter;
